import { useEffect } from "react";
import styles from "./Contact.module.scss";
// components
import MainHeader from "../../components/Header/MainHeader";
import { Link } from "react-router-dom";

import { HiOutlineMail } from "react-icons/hi";
import { LuPhoneCall } from "react-icons/lu";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { getEnvironment } from "../../utils/environment";
import { googleEvent_LOJ020, googleEvent_LOJ022, googleEvent_LOJ023 } from "../../lib/google-analytics";

export default function Contact() {
  const { PRODUCT } = getEnvironment();

  useEffect(() => {
    googleEvent_LOJ020();
  }, []);

  const contact = {
    ramfincorp: {
      email: "info@ramfincorp.com",
      phone: ["9599196212", "9599238889"],
    },
    kamakshi: {
      email: "info@kamakshimoney.com",
      phone: ["9220429444"],
    },
  };

  const selectedAddress = PRODUCT === "ramfincorp_api" ? contact.ramfincorp : contact.kamakshi;

  return (
    <>
      <div className={`wrapper ${styles.contact__us}`}>
        <MainHeader title="Contact Us" showProgress={false} />
        <div className="mb-3">
          <p className="label">Contact us for all your queries</p>
        </div>

        <Link to={`mailto:${selectedAddress.email}`} className={styles.list} onClick={googleEvent_LOJ022}>
          <div className={styles.icon}>
            <HiOutlineMail size={22} />
          </div>
          <div className={styles.content}>
            <div>
              <h5>{selectedAddress.email}</h5>
              <span>Click here to drop an email to us</span>
            </div>
            <div className={styles.arrow}>
              <MdOutlineKeyboardArrowRight color="#000000" size={24} />
            </div>
          </div>
        </Link>

        {selectedAddress.phone.map((number, index) => (
          <Link
            key={index}
            to={`tel:${number}`}
            className={styles.list}
            onClick={googleEvent_LOJ023}
          >
            <div className={styles.icon}>
              <LuPhoneCall size={22} />
            </div>
            <div className={styles.content}>
              <div>
                <h5>+91 {number}</h5>
                <span>Click here to call us</span>
              </div>
              <div className={styles.arrow}>
                <MdOutlineKeyboardArrowRight color="#000000" size={24} />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </>
  );
}
